// Détecter si l'utilisateur est sur mobile
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // Détection iOS
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  
  // Détection Android
  const isAndroid = /android/i.test(userAgent);
  
  // Détection générique mobile
  const isMobileGeneric = /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  
  return isIOS || isAndroid || isMobileGeneric;
};

// Détecter le système d'exploitation mobile
export const getMobileOS = (): 'iOS' | 'Android' | 'other' => {
  if (typeof window === 'undefined') return 'other';
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return 'iOS';
  }
  
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  
  return 'other';
};

// URLs des stores
export const APP_STORE_URLS = {
  iOS: 'https://apps.apple.com/be/app/property-assist/id6450917128',
  Android: 'https://play.google.com/store/apps/details?id=com.louisv2304.oosmoseproperties',
};
